<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#f487e0"
    :border="true"
    inactive-color="#888"
  >
  <!-- 首页 -->
    <van-tabbar-item to="/Choose">
      <span>{{ $t("foorter.choose") }}</span>
      <template #icon="props">
        <svg class="tabbar-svg" :class="{ active: props.active, big: show === 0 }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </template>
    </van-tabbar-item>
    <!-- 预约 -->
    <van-tabbar-item to="/Game">
      <span>{{ $t("foorter.subscribe") }}</span>
      <template #icon="props">
        <svg class="tabbar-svg" :class="{ active: props.active, big: show === 1 }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      </template>
    </van-tabbar-item>
    <!-- 中间 -->
    <van-tabbar-item to="/Home">
      <span>首页</span>
      <template #icon="props">
        <div class="tui" :class="{ active: props.active }">
          <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path>
          </svg>
        </div>
      </template>
    </van-tabbar-item>
    <!-- 视频 -->
    <van-tabbar-item to="/Video">
      <span>{{ $t("foorter.video") }}</span>
      <template #icon="props">
        <svg class="tabbar-svg" :class="{ active: props.active, big: show === 3 }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="23 7 16 12 23 17 23 7"></polygon>
          <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
        </svg>
      </template>
    </van-tabbar-item>
    <!-- 我的 -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <svg class="tabbar-svg" :class="{ active: props.active, big: show === 4 }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {
    /**
     * 根据当前路由名同步 tabbar 的激活索引与显隐
     * 当前 tabbar DOM 顺序（按 <van-tabbar-item> 出现顺序）：
     *   index 0  to="/Choose"  name=choose   (首页/同城约课)
     *   index 1  to="/Game"    name=game     (预约)
     *   index 2  to="/Home"    name=home     (中间大圆 首页)
     *   index 3  to="/Video"   name=video    (视频)
     *   index 4  to="/Mine"    name=mine     (我的)
     */
    syncFromRoute(routeName) {
      switch (routeName) {
        case 'choose':
          this.active = 0;
          this.show = true;
          break;
        case 'game':
          this.active = 1;
          this.show = true;
          break;
        case 'home':
          this.active = 2;
          this.show = true;
          break;
        case 'video':
          this.active = 3;
          this.show = true;
          break;
        case 'mine':
          this.active = 4;
          this.show = true;
          break;
        default:
          this.show = false;
      }
    }
  },
  watch: {
    $route(to) {
      this.syncFromRoute(to.name);
    },
  },
  created() {
    this.syncFromRoute(this.$route.name);
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
.van-tabbar {
  height: @tabbar-height;
  background-color: #1a1a1a;
}
.van-tabbar-item {
  font-size: 26px;
  background-color: #1a1a1a;
}
.tabbar-svg {
  width: 48px;
  height: 48px;
  color: #888;
  transition: all 0.3s;
}
.tabbar-svg.active {
  color: #f487e0;
}
.tabbar-svg.big {
  width: 64px;
  height: 64px;
}
.tui {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -30px;
  background-color: #1a1a1a;
  border-radius: 50%;
  border: 6px solid #1a1a1a;
  box-shadow: 0 0 0 2px #2a2a2a;
  z-index: 10;
}
.tui svg {
  width: 40px;
  height: 40px;
  color: #888;
  transition: all 0.3s;
}
.tui.active svg {
  color: #f487e0;
}
[class*="van-hairline"]::after {
  border: none !important;
}
</style>
